export default __webpack_public_path__ + "static/media/illustration_games-organizations.3744ea9c.png";